import { isMonday, isSunday, nextSunday, previousMonday } from 'date-fns';

import { splitDate } from '@/helpers/dates';

const currentDate = new Date();

export const monday = splitDate(
	isMonday(currentDate)
		? currentDate.toLocaleDateString()
		: previousMonday(currentDate).toLocaleDateString()
);
export const sunday = splitDate(
	isSunday(currentDate)
		? currentDate.toLocaleDateString()
		: nextSunday(currentDate).toLocaleDateString()
);
